import $ from 'jquery';
import LogRocket from 'logrocket';
import config from 'lib/config';

const $W = $(window);
const $B = $('body');
let enabled = false;
let timer;

const ADD_LOGROCKET_SESSION = `
  mutation addLogRocketSession($url: String!) {
    addLogRocketSession(url: $url)
  }
`;

const enableLogRocket = async ({ user, website, client }) => {
  if (enabled) return;
  if (timer) clearTimeout(timer);

  enabled = true;
  $B.addClass('use-logrocket');
  console.log('🚀 LOGROCKET:ENABLED');

  LogRocket.init(config.logrocket.app_id);

  LogRocket.identify(user.id.toString(), {
    version: config.admin.version,
    name: `${user.first_name} ${user.last_name}`,
    email: user.email?.email,
    username: user.username,
    website_id: website.id,
    website_name: website.name,
    client_id: client.id,
    client_name: client.name,
  });

  LogRocket.getSessionURL(async url => {
    await $.GraphQL.runQuery(ADD_LOGROCKET_SESSION, {
      operationName: 'addLogRocketSession',
      variables: { url },
    });
  });
};

const disableLogRocket = async () => {
  if (!enabled) return;

  enabled = false;
  $B.removeClass('use-logrocket');
  console.log('🚀 LOGROCKET:DISABLED');

  LogRocket.uninstall();
};

$.onAuth(async auth => {
  $W.on('notify:logrocket', async (evt, data) => {
    if (data) await enableLogRocket(auth);
    else
      timer = setTimeout(async () => {
        await disableLogRocket();
      }, 1000);
  });

  if (!config.dev && auth.user && auth.user.use_logrocket) await enableLogRocket(auth);
});
